/**
 * Tester names and the owner's own preview runs.
 *
 * - `testerName` is the optional first name a tester types on the start
 *   screen (both tester flows). It is written once, when the session doc is
 *   created, so today's Firestore rules already allow it.
 * - `isOwnerPreview: true` marks a "Preview as tester" run: the owner, signed
 *   in, running their own test. These runs are recorded as "You", are free
 *   (left out of the plan's session allowance) and are left out of Insights.
 *
 * Owner screens name a session with `sessionDisplayName` and number it with
 * `getSessionNumbers` (src/pages/UserTesting/insights/insightsModel.js);
 * previews get no number. This file only cleans typed names and counts the
 * sessions that use up the plan's allowance.
 */
import { isOwnerPreview } from '../pages/UserTesting/insights/insightsModel';

export const TESTER_NAME_MAX = 40;
export const OWNER_PREVIEW_NAME = 'You';

/** Trim, collapse spaces and cap a typed name. Returns '' when nothing is left. */
export function cleanTesterName(raw) {
  if (typeof raw !== 'string') return '';
  return raw.replace(/\s+/g, ' ').trim().slice(0, TESTER_NAME_MAX).trim();
}

/**
 * Sessions that count towards the plan's session allowance: every stored
 * session except the owner's own preview runs. Takes a Firestore
 * QuerySnapshot (compat or Admin SDK) or an array of plain session objects.
 */
export function countAllowanceSessions(snapshotOrSessions) {
  if (!snapshotOrSessions) return 0;
  const items = Array.isArray(snapshotOrSessions)
    ? snapshotOrSessions
    : (snapshotOrSessions.docs || []).map((d) => (typeof d.data === 'function' ? d.data() : d));
  return items.filter((s) => !isOwnerPreview(s)).length;
}
